import ReactDOM from 'react-dom';
import React, { useEffect, useState } from 'react';

import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import './Component.css'
import { Workspace } from 'polotno/canvas/workspace';
import { SidePanel, DEFAULT_SECTIONS } from 'polotno/side-panel';
import { Toolbar } from 'polotno/toolbar/toolbar';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';
import { createStore } from 'polotno/model/store';
import { Sticker } from './Component/Sticker';
import { CustomCard } from './Component/Card';
import { setTranslations } from 'polotno/config';
import Topbar from './Component/TopBar';
import { CustomText } from './Component/Text';
import { CustomSize } from './Component/Resize';
import { checkSession } from '../../services';
import { useHistory } from "react-router-dom";
setTranslations({
    sidePanel: {
        templates: 'Greeting card',
        background: 'null',
    },
})
let defaultSection = [DEFAULT_SECTIONS[4],]
// defaultSection.splice(0, 1)
// defaultSection.splice(1, 2)
// defaultSection.splice(2, 1)
const customSection = [CustomSize, CustomCard, Sticker, CustomText, ...defaultSection]
const store = createStore({});
export default function Canva() {
    const history = useHistory();
    useEffect(() => {
        store.addPage()
        const sessionId = localStorage.getItem("sessionId")
        if (sessionId) {
            const data = {
                sessionId
            }
            checkSession(data).then(res => {
                if (res.data.responseCode != 200) removeData()
            })
        }
        else { removeData() }
    }, [])
    const removeData = () => {
        const pagesIds = store.pages.map((p) => p.id);
        store.deletePages(pagesIds);
        history.push("/")
    }
    return (
        <div className="polotno-app-container">
            <Topbar store={store} />
            <PolotnoContainer >
                <SidePanelWrap >
                    <SidePanel style={{ width: "10em" }} store={store} sections={customSection} defaultSection="upload" />
                </SidePanelWrap>
                <WorkspaceWrap>
                    <Toolbar store={store} />
                    <Workspace store={store} />
                    <ZoomButtons store={store} />
                </WorkspaceWrap>
            </PolotnoContainer>
        </div>
    );
}